import React, { Component } from 'react';
import GlslCanvas from 'glslCanvas';
// import Shader from './BackgroundShader.frag';
import ShaderTwo from './Shaders/ShaderTwo.frag';
import SekerBG from '../Img/seker_bg.png';

export default class BackgroundEffects extends Component {
 
    state = {lastStep:0, imgLoaded:false}

    componentDidMount(){
        const canvas = document.getElementById("glslCanvas");
        global.sandbox = new GlslCanvas(canvas);

        window.onload = ()=>{

            global.sandbox.setUniform("u_seed",Math.random(),Math.random());
            global.sandbox.setUniform("u_phase",0.0); 
            global.sandbox.setUniform("u_animspeed",0.05);
            global.sandbox.setUniform("u_bgColor",0.922,0.925,0.937); 
        }
        
        global.setBgStep = (step)=>{

            let lastStep = this.state.lastStep;

            const targetStep = Math.pow(Math.min(Math.cos(0.5*Math.PI*(1-step)),1-Math.abs(1-step)),0.8);
            let t = 0;

            this.setState({lastStep:targetStep});
            
            const animReq = window.requestAnimationFrame(function stepAnim(){
                if(t < 1){
                    t += 0.01;
                    const f = Math.pow(Math.sin(Math.PI*t*0.5),0.8);

                    const interpolated = lastStep + (targetStep - lastStep)*f;                   
                    global.sandbox.setUniform("u_phase",interpolated);

                    const animSpeed = 0.05 + (0.03/targetStep) * Math.sin(Math.PI*f);
                    // console.log(animSpeed);
                    global.sandbox.setUniform("u_animspeed", animSpeed);

                    window.requestAnimationFrame(stepAnim);
                } else {
                    window.cancelAnimationFrame(animReq);
                    t = 0;
                }
            })            
        }

    }

    componentDidUpdate(){
        const {imgUrl} = this.props;
        if(imgUrl !== "" && !this.state.imgLoaded){
            // console.log("did get url: " + this.props.imgUrl);
            global.sandbox.setUniform("u_tex0",`${global.URL}/getImg/${imgUrl.split('amazonaws.com/')[1]}`);
            this.setState({imgLoaded: true});
        }
    }


	render() {       
        const {canvasWidth, canvasHeight} = this.props;
        const dpr = window.devicePixelRatio;

        let canvasSize;

        if(canvasWidth > canvasHeight){
            canvasSize = canvasWidth;
        } else {canvasSize = canvasHeight}

        return <canvas id="glslCanvas" data-fragment-url={ShaderTwo} data-textures={SekerBG} 
            width={canvasSize*dpr} height={canvasSize*dpr}
            style={{
                position: "absolute",
                width: canvasSize,
                height: canvasSize,
                left: (canvasWidth- canvasSize) / 2,
                bottom: (canvasHeight - canvasSize) / 2,
            }}
        ></canvas>
    }

}




// WEBPACK FOOTER //
// ./src/Comp/BackgroundEffects.js